/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleRentalPeriodRules
 */
export interface VehicleRentalPeriodRules {
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalPeriodRules
     */
    minRentalDays?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalPeriodRules
     */
    maxRentalDays?: number;
}

/**
 * Check if a given object implements the VehicleRentalPeriodRules interface.
 */
export function instanceOfVehicleRentalPeriodRules(value: object): value is VehicleRentalPeriodRules {
    return true;
}

export function VehicleRentalPeriodRulesFromJSON(json: any): VehicleRentalPeriodRules {
    return VehicleRentalPeriodRulesFromJSONTyped(json, false);
}

export function VehicleRentalPeriodRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRentalPeriodRules {
    if (json == null) {
        return json;
    }
    return {
        
        'minRentalDays': json['min_rental_days'] == null ? undefined : json['min_rental_days'],
        'maxRentalDays': json['max_rental_days'] == null ? undefined : json['max_rental_days'],
    };
}

export function VehicleRentalPeriodRulesToJSON(json: any): VehicleRentalPeriodRules {
    return VehicleRentalPeriodRulesToJSONTyped(json, false);
}

export function VehicleRentalPeriodRulesToJSONTyped(value?: VehicleRentalPeriodRules | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min_rental_days': value['minRentalDays'],
        'max_rental_days': value['maxRentalDays'],
    };
}

